import React from 'react'

const DropdownMenuItem = (props) => {
    let onClick=props.onClick; // logout gets func passed in
    if (onClick === undefined) // not login part of menu
    {
        onClick = () => {
            props.goToMenu && props.setActiveMenu(props.goToMenu)
            
            if (props.changeTabIndex > -1){
                props.changeTabState(null, props.changeTabIndex)
            }
        }
    }
    return (
        <a href={props.link} className="nav-menu-item" onClick={onClick }>
            <span className="icon-button" style={{backgroundColor: props.buttonBgColor, color: 'black',fontSize: '1.5em'}}>{props.leftIcon}</span>
            <span className="icon-botton-spacing">&nbsp;</span>
            {props.children}
            <span className="icon-right">{props.rightIcon}</span>
        </a>
    );
}

export default DropdownMenuItem
